import App from './App.vue';
import router from './router';
import './assets/styles/main.scss';
import i18n from '@/shared/plugins/i18n';
import { initApp } from '@/shared/main';
import { configEnv } from '@/shared/config-env';

initApp(App, router, i18n, configEnv.MTI_CLIENT_ID);
